<template>
  <v-container
    fluid
    tag="section"
  >
    <v-row>
      <v-col
        cols="12"
        md="10"
      >
        <div
          class="font-weight-medium ml-5"
          style="font-size: 20px"
        >
          {{PageTitle}}       
        </div>
      </v-col>
    </v-row>
      
    <v-card>
      <v-container fluid class="pa-5">
        <v-form v-model="portfolioFormValid">
          <v-row>
            <v-col cols="12" md="6">
              <v-list-item 
                class="pa-0"
                v-if="peerGroupFormDisabled"
                two-line
              >
                <v-list-item-content>
                  <v-list-item-title>{{ peerGroupDescription.name }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-text-field
                v-else
                v-model="peerGroupDescription.name"
                label="Peer Group Name"
                class="purple-input"
                :rules="[rules.required]"
                counter
                maxlength="200"                
              />
            </v-col>        
          </v-row>            
          <v-row>
            <v-col
              cols="12"
              md="12"
            >
              <v-list-item 
                v-if="peerGroupFormDisabled"
                two-line
                class="pa-0"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ peerGroupDescription.description }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>              
              <v-textarea
                v-else
                v-model="peerGroupDescription.description"
                label="Description"
                class="purple-input"
                counter
                maxlength="500"                                
                :rules="[rules.counter500]"
              />
            </v-col>
          </v-row>


          <v-row> 
            <v-col
              cols="12"
              class="text-right"
            >


              <v-btn
                :disabled="!portfolioFormValid"
                v-if="!peerGroupFormDisabled"
                color="primary"
                class="mr-3"
                @click="savePeerGroup()"
                :loading="loadingButtonDes"
              >
                Save
              </v-btn>

              <v-btn
                :disabled="!portfolioFormValid"
                v-if="!peerGroupFormDisabled"
                color="primary"
                text
                @click="enableEditPortfolio()"
              >
                Cancel
              </v-btn>

              <v-btn
                v-if="peerGroupFormDisabled"
                color="primary"
                class="mr-3"
                @click="enableEditPortfolio()"
              >
                Edit
              </v-btn>             
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>

    <v-card class="mt-5" v-if="id">
      <v-container fluid class="pa-5">
        <v-row>
          <v-col cols="12" md="6">
            <p>Peer Group Constituents</p>
          </v-col>                       
        </v-row>  

        <v-row>                                
          <v-col cols="12">
            <v-overlay
              :absolute="absolute"
              :opacity="opacity"
              :value="overlay"
            >
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>                     
            <v-data-table
              :headers="headers"
              :items="peerGroupConstituents"
              :search.sync="search"
              :mobile-breakpoint="0"
            >
              <template v-slot:top>

                  <v-dialog v-model="dialogAdd" max-width="600px">
                    <template v-slot:activator="{ on }">
                      <v-row >
                        <v-col>
                          <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Filter"
                            single-line
                            hide-details
                          ></v-text-field>    
                        </v-col>      
                        <v-spacer></v-spacer>              
                        <v-col class="text-right">
                          <v-btn color="primary" class="mr-0" v-on="on" > <v-icon left>mdi-plus</v-icon>Add Investor</v-btn>
                        </v-col>
                      </v-row>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>
                      <v-card-subtitle>
                        Select an Investor
                      </v-card-subtitle>


                      <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12">
                                <v-autocomplete
                                  v-if="editedIndex === -1"
                                  :items="investorItems"
                                  :loading="isLoading"
                                  :search-input.sync="searchInvestor"
                                  item-text="name"
                                  item-value="id"
                                  placeholder="Search Investor"
                                  prepend-icon="mdi-magnify"
                                  flat
                                  clearable
                                  open-on-clear
                                  no-filter
                                  :menu-props="{ closeOnContentClick: true }"

                                >
                                  <template v-slot:no-data>
                                    <v-list-item>
                                      <v-list-item-title>
                                        Search for 
                                        <strong>investors</strong>
                                      </v-list-item-title>
                                    </v-list-item>
                                  </template>

                                  <template v-slot:item="{ item }">
                                    <v-list-item  @click="selectStockItem(item)">        
                                      <v-list-item-content>
                                        <v-list-item-title v-text="item.name"></v-list-item-title>
                                        <v-list-item-subtitle v-text="item.classif + '  |  $ ' + item.aum + '  |  ' + item.nb_positions + ' holdings'"></v-list-item-subtitle>
                                      </v-list-item-content>
                                      <v-list-item-action>
                                        <v-icon>mdi-magnify</v-icon>
                                      </v-list-item-action>
                                    </v-list-item>
                                  </template>
                                </v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" md="6" >
                                <v-text-field disabled v-model="editedItem.name" label="Investor"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text @click="close">Cancel</v-btn>
                        <v-btn color="primary" @click="saveRow">Add</v-btn>
                      </v-card-actions>                        

                    </v-card>
                  </v-dialog>                

              </template>    
 
              <template v-slot:item="row">
                <tr>
                  <td>
                    <v-btn
                      v-if="!row.item.isCash"
                      class="px-2 mr-2"
                      color="primary"
                      min-width="0"
                      icon
                      small
                      :to="'/investors/analyze/' + row.item.id"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">
                            mdi-magnify-plus-outline
                          </v-icon>                        
                        </template>
                        <span>Analyze</span>
                      </v-tooltip> 
                    </v-btn>
                  </td>
                  <td>{{ row.item.name }}</td>
                  <td>{{ row.item.classif }}</td>                  
                  <td>$ {{ row.item.aum }}</td>                  
                  <td class="text-right">
                    <span class="px-4">
                      {{row.item.nb_positions}}
                    </span>
                  </td>
                  <td class="text-center">
                    <v-btn
                      v-if="!row.item.isCash"
                      class="px-2 ml-1"
                      color="primary"
                      outlined
                      min-width="0"
                      small
                      @click="showDeletePeerGroupInvestorConfirmation(row.item.id)"
                    >
                        <v-icon small>
                          mdi-delete
                        </v-icon>  
                      Delete
                    </v-btn>
                  </td>
                </tr>
              </template>

              <!-- <template v-slot:no-data>
                <v-btn color="primary" @click="dialogAdd=true">Add a Position</v-btn>
              </template> -->

            </v-data-table>
            <!-- <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                class="mr-3"
                @click="saveConstituents()"
                :loading="loadingButtonConstituents"
                :disabled="disabledSaveConstituents"
              >
                Save Constituents
              </v-btn>
            </v-card-actions>             -->
          </v-col>
        </v-row>
        <!-- <v-row v-else>
          <v-col>
            <v-card-text>
              No constituents provided
            </v-card-text>
          </v-col>
        </v-row>         -->
      </v-container>

    </v-card>

    
    <v-card class="mt-5">
        <v-row>
          <v-col>
            <p>Statistics <span id="performance"></span> -
                <v-btn 
                  text 
                  small
                  color="primary"
                  
                  @click.stop="listDialog= true"
                >
                  See Performance of Investors within this peer group.
                </v-btn>              
              <!-- <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon dense small style="color: #e1e4ea; " v-on="on">mdi-information-outline </v-icon>
                </template>
                <span>Performance is estimated and might differ from real performance. Specifically, it may omit short positions and holdings that are not part of our universe.</span>
              </v-tooltip> -->
            </p>             
              <span>
             
                  <v-dialog v-model="listDialog">
                      <v-card class="px-7" style="background: #121212;">
                        <v-row>
                          <investors-performance-table :element="id" :type="'peer'"></investors-performance-table>        
                        </v-row>
                        <v-card-actions>    
                          <v-spacer></v-spacer>             
                          <v-btn color="primary" text @click="listDialog = false">Close</v-btn>
                        </v-card-actions> 
                      </v-card>                
                  </v-dialog>
            </span>
          </v-col>          
        </v-row>      
    </v-card>

    <v-snackbar
      v-model="errorbar"
      :color="colorSnackbar"
      :timeout="0"
    >
      {{errorMessage}}
      <v-btn
        text
        @click="errorbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>


    <confirmation-dialog
      v-if="confirmationDialog.isOpen"
      :title="confirmationDialog.title"
      :disabled="confirmationDialog.isDisabled"
      @accept="confirmationDialog.acceptCallback"
      @cancel="confirmationDialog.cancleCallback"
    ></confirmation-dialog>

    <v-snackbar :timeout="0" :color="snackbar.color" v-model="snackbar.isOpen">
      {{ snackbar.text }}

      <v-btn
        small
        dark
        icon
        @click="snackbar.isOpen = false"
      >
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>    

        <!-- <v-btn
        text
        @click="errorbar = true"
      >
        snack
      </v-btn>  -->
  </v-container>
     
</template>

<script>
  import moment from 'moment'
  import ConfirmationDialog from '@/components/ConfirmationDialog'

  export default {
    name: 'peerGroupModify',
    components: {
      ConfirmationDialog,
      InvestorsPerformanceTable: () => import('@/components/InvestorsPerformanceTable'),
    },    
    props:{
      id: {
        type: String,
        required: false
      }
    }, 
    data() {
      return {     
        absolute: true,
        opacity: 0.46,
        overlay: false,  
        calendarDialog: false,       
        PageTitle: "Add a Peer Group",
        dialogAdd: false,    
        listDialog:false,
        isLoading: false,
        loadingButtonDes:false,
        loadingButtonConstituents:false,
        model: null,    
        portfolioFormValid: false,
        rules: {
          required: value => !!value || 'Required.',
          counter: value => value.length <= 200 || 'Max 200 characters',
          counter500: value => value.length <= 500 || 'Max 500 characters',
        },
        //searchDate: null,//new Date().toISOString().substr(0, 10),
        isSelecting: false,
        peerGroupFormDisabled: false,
        peerGroupDescription: {
          name: "",
          description: "",
        },
        peerGroupConstituents: [],    
        search: '',
        headers: [
          {
            sortable: false,
            text: '',
            align: 'left',
          },
          { text: 'Name', value: 'name' },
          { text: 'Classification', value: 'classif' },
          { text: 'Portfolio Size', value: 'aum' },
          { text: '# Positions', value: 'nb_positions', align: 'right' },
        ],
        investorItems: [
        ],
        
        searchInvestor: '',
        errorbar: false,
        colorSnackbar: "primary",
        colorSnackbarSuccess: "primary",
        colorSnackbarError: 'error',
        errorMessage:"An error has occurred/Could not locate this peer group",
        buttonLoading: false,        
        editedIndex: -1,
        editedItem: {
          name: '',
          id:null,
          classif:'',
          aum:0,
          nb_positions:0
        },
        defaultItem: {
          name: '',
          id:null,
          classif:'',
          aum:0,
          nb_positions:0
        },      
        disabledSaveConstituents:true,
        snackbar: {
          text: "",
          isOpen: false,
          color: "green",
        },
        confirmationDialog: getDefaultConfirmationDialog(),
      }
    },
    mounted() {
      if (this.id) {
        this.PageTitle="Modify Peer Group"
        this.getPeerGroupById()
        this.peerGroupFormDisabled=true
      }
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Add an Investor' : 'Edit an Investor'
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
    //Watch used for search bar
      model (val) {
        if (val != null) this.tab = 0
        else this.tab = null
      },
      searchInvestor () {
        this.isLoading = true
        this.fetchEntriesDebounced()
      }, 
      peerGroupConstituents(){
        if (this.peerGroupConstituents.length>0) {
          this.disabledSaveConstituents=false; 
        } else {
          this.disabledSaveConstituents=false; // true; // disable save constituents
        }
      }
    },    
    methods: {
      fetchEntriesDebounced() {
        // cancel pending call
        clearTimeout(this._timerId)

        // delay new call 500ms
        this._timerId = setTimeout(() => {
          this.getSearchFromApi (this.searchInvestor) 
        }, 500)
      },         
      formatDate(value) {
        return moment(String(value)).format("YYYY-MM-DD h:mm")
      },
      async getPeerGroupById() {
        var self = this
        const currentSession = await this.$Amplify.Auth.currentSession()
        const currentToken = currentSession.getIdToken().getJwtToken()
        this.$http.get(process.env.VUE_APP_API_HOST + '/get-peergroup-by-id/' + this.id,{
            headers: {
              'Authorization': currentToken,
              'Content-Type': 'application/json'
            }
          }).then(function (response) {
            ////console.log(response.data)
            self.peerGroupDescription = response.data;
            self.peerGroupConstituents = response.data.constituents;
          }).catch(function (/*error*/) {            
            self.colorSnackbar= self.colorSnackbarError;
            self.errorMessage= "An error has occurred/Could not locate this peer group";
            self.errorbar= true;
          });
      },
      async updatepeerGroupConstituents() {
        var self = this
        this.overlay=true
        const currentSession = await this.$Amplify.Auth.currentSession()
        const currentToken = currentSession.getIdToken().getJwtToken()
        this.$http.get(process.env.VUE_APP_API_HOST + '/get-peergroup-by-id/' + this.id ,{
            headers: {
              'Authorization': currentToken,
              'Content-Type': 'application/json'
            }
          }).then(function (response) {
            self.peerGroupConstituents = response.data.constituents;
            self.overlay=false;   
          }).catch(function (/*error*/) {
            self.colorSnackbar= self.colorSnackbarError;
            self.errorMessage= "An error has occurred/Could not locate any peer group";
            self.errorbar= true;
            self.overlay=false;
            self.peerGroupConstituents=[]
          });
      },      
      showDeletePeerGroupInvestorConfirmation (item) {
        this.confirmationDialog = {
          ...this.confirmationDialog,
          title: 'Are you sure you want to delete?',
          isOpen: true,
          acceptCallback: () => {
            this.deletePeerGroupInvestor(item)
            this.confirmationDialog = getDefaultConfirmationDialog()
          },
          cancleCallback: () => this.confirmationDialog = getDefaultConfirmationDialog()
        }
      },
      async deletePeerGroupInvestor (item) {
        var self = this        
        const currentSession = await this.$Amplify.Auth.currentSession()      
        const currentToken = currentSession.getIdToken().getJwtToken()  
        //const index = self.peerGroupConstituents.indexOf(item)
        this.$http.put(process.env.VUE_APP_API_HOST + '/set-peergroup-investor/' + this.id + '/' + item + '/delete',{},{
            headers: {
              'Authorization': currentToken,
              'Content-Type': 'application/json'
            }
          }).then(function (response) {
            //console.log(response);
            self.updatepeerGroupConstituents();
            self.colorSnackbar= self.colorSnackbarSuccess;            
            self.errorMessage= "Success! " + response.data.message;         
            self.errorbar= true;
            }
          ).catch(function (error) {
            self.colorSnackbar= self.colorSnackbarError;  
            //self.loadingButtonDes= false;
            self.errorbar= true;
            self.updatepeerGroupConstituents();              
            if (error.response) {
              self.errorMessage= "ERROR - " + error.response.data.error;               
            }                      
          });
      },
      async addPeerGroupInvestor (item) {
        var self = this
        const currentSession = await this.$Amplify.Auth.currentSession()      
        const currentToken = currentSession.getIdToken().getJwtToken()  
        //const index = self.peerGroupConstituents.indexOf(item)
        this.$http.put(process.env.VUE_APP_API_HOST + '/set-peergroup-investor/' + this.id + '/' + item + '/add',{},{
            headers: {
              'Authorization': currentToken,
              'Content-Type': 'application/json'
            }
          }).then(function (response) {
            self.colorSnackbar= self.colorSnackbarSuccess;            
            self.errorMessage= "Success! " + response.data.message;  
            self.errorbar= true; 
            self.updatepeerGroupConstituents();
            //self.peerGroupConstituents.splice(self.peerGroupConstituents.indexOf(response.data.investor), 1)          
            }
          ).catch(function (error) {
            self.colorSnackbar= self.colorSnackbarError;  
            //self.loadingButtonDes= false;
            self.errorbar= true;
            self.updatepeerGroupConstituents();             
            if (error.response) {
              self.errorMessage= "ERROR - " + error.response.data.error;               
            }                    
          });
      },      
      selectStockItem(item) {
        this.editedItem.name = item.name
        this.editedItem.id = item.id
        this.editedItem.classif = item.classif
        this.editedItem.aum = item.aum        
        this.editedItem.nb_positions = item.nb_positions
        //this.investorItems = [];
      },
      savePeerGroup () {
        this.postPeerGroupDescriptionUpsert()
      },
      saveConstituents () {
        this.confirmAndsavePeerGroupConstituentsUpsert()
      },
      async postPeerGroupDescriptionUpsert() {
        var self = this
        self.loadingButtonDes= true;        
        var peerGroup = {description: this.extractDescriptionOnly()}
        //console.log(peerGroup)
        const currentSession = await this.$Amplify.Auth.currentSession()
        const currentToken = currentSession.getIdToken().getJwtToken()
        var api_endpoint='/upsert-peer-group'
        if (this.id) {
          api_endpoint='/upsert-peer-group/' + this.id
        }
        this.$http.post(process.env.VUE_APP_API_HOST + api_endpoint,peerGroup,{
            headers: {
              'Authorization': currentToken,
              'Content-Type': 'application/json'
            }
          }).then(function (response) {
            //console.log(response.data)
            self.colorSnackbar= self.colorSnackbarSuccess;            
            self.errorMessage= "Success! " + response.data.message;   
            self.errorbar= true;                         
            self.loadingButtonDes= false;
            if (typeof self.id == 'undefined') {
              self.id = response.data.id
              //console.log(self.id )
            self.peerGroupFormDisabled = true              
            }
          }).catch(function (error) {
            self.colorSnackbar= self.colorSnackbarError;  
            self.errorMessage= error;              
            self.loadingButtonDes= false;
            //console.log(error)    
            self.errorbar= true;
            if (error.response) {
              self.errorMessage= "ERROR - " + error.response.data.error;               
            }                 
          });
      },
      confirmAndsavePeerGroupConstituentsUpsert () {
        if (this.peerGroupDescription.weightedScheme == 0) {
          this.postpeerGroupConstituentsUpsert()
          return
        }
        this.postpeerGroupConstituentsUpsert()
      },
      async postpeerGroupConstituentsUpsert() {
        var self = this
        this.loadingButtonConstituents = true;        
        var portfolio ={}
        if (this.id) {
          portfolio =  {constituents: {
                            constituents: this.peerGroupConstituents,
                          }
                        }
        } else {
          portfolio = {description: this.extractDescriptionOnly(),
                      constituents: {
                        constituents: this.peerGroupConstituents,
                        }
                      }
        }        
        //console.log(portfolio)
        const currentSession = await this.$Amplify.Auth.currentSession()
        const currentToken = currentSession.getIdToken().getJwtToken()
        var api_endpoint='/upsert-peer-group'        
        if (this.id) {
          api_endpoint='/upsert-peer-group/' + this.id
        }
        this.$http.post(process.env.VUE_APP_API_HOST + api_endpoint,portfolio,{
            headers: {
              'Authorization': currentToken,
              'Content-Type': 'application/json'
            }
          }).then(function (response) {
            //console.log(response.data)
            self.colorSnackbar= self.colorSnackbarSuccess;  
            self.errorMessage= "Success! " + response.data.message;   
            self.errorbar= true;
            self.loadingButtonConstituents= false;
            self.getPeerGroupById();
          }).catch(function (error) {
            self.loadingButtonConstituents= false;
            //console.log(error) 
            self.colorSnackbar= self.colorSnackbarError;  
            self.errorMessage= error;    
            self.errorbar= true;
            if (error.response) {
              self.errorMessage= "ERROR - " + error.response.data.error;               
            }
          });
      },      
      extractDescriptionOnly() {
        return  {
          name:  this.peerGroupDescription.name,
          description:  this.peerGroupDescription.description,
        }
      },
      enableEditPortfolio () {
        this.peerGroupFormDisabled = !this.peerGroupFormDisabled  
        //this.peerGroupFormDisabled = false
      },
      resetSearchForm () {
        this.portfolioName = ''
        this.pcode = []
        this.strategy = []
      },
      close () {
        this.dialogAdd = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      saveRow () {      
        this.addPeerGroupInvestor(this.editedItem.id)
        // if (this.editedIndex > -1) {
        //   Object.assign(this.peerGroupConstituents[this.editedIndex], this.editedItem)
        // } else {
        //   this.peerGroupConstituents.push(this.editedItem)
        // }
        this.close()
      },
      customFilter (item, queryText, itemText) {
        const textOne = itemText ? itemText.toLowerCase() : "";
        const textTwo = item.ric ? item.ric.toLowerCase() : "" ;
        const textThree = item.ticker ? item.ticker.toLowerCase() : "";
        const textFour = item.isin ? item.isin.toLowerCase(): "";
        const searchText = queryText ? queryText.toLowerCase(): "";

        return textOne.indexOf(searchText) > -1 ||
          textTwo.indexOf(searchText) > -1 ||
          textThree.indexOf(searchText) > -1 ||
          textFour.indexOf(searchText) > -1
      }, 
      async getSearchFromApi (search) {
        var self = this
        const currentSession = await this.$Amplify.Auth.currentSession()
        const currentToken = currentSession.getIdToken().getJwtToken()
        //console.log({filter: search})
        this.$http.post(process.env.VUE_APP_API_HOST + '/get-investors-search',{filter: search},{
          headers: {
            'Authorization': currentToken,
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          //console.log(response.data)
          self.investorItems = response.data
        }).catch(function (/*error*/) {
          //console.log(err)
        }).finally(() => (this.isLoading = false))    
      },       
      displaySnackbar({ text, color }) {
        this.snackbar = {
          text,
          color,
          isOpen: true,
        };
      },
    }
  }

function getDefaultConfirmationDialog ()   {
  return {
    title: '',
    isOpen: false,
    isDisabled: false,
    acceptCallback: () => {},
    cancleCallback: () => {}
  }  
}  
</script>
